import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const { CALL_STATE, LOADING, OPERATIONS, OPERATIONS_RAW, SELECTED_OPERATION } =
  STATE_IDENTIFIER;

export default {
  [CALL_STATE]: IResponseState.PENDING,
  [LOADING]: false,
  [OPERATIONS]: [],
  [OPERATIONS_RAW]: [],
  [SELECTED_OPERATION]: null,
};
